import { ISmartScheduleShiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("updateSlotsSmartScheduleShift", function updateSlotsSmartScheduleShift(slots: number) {
    if (shiftEditorViewState().smartScheduleShift) {
        const shift = shiftEditorViewState().smartScheduleShift as ISmartScheduleShiftEntity;
        shift.openSlots = slots;
    }
});
